import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export interface RichTextEditorProps {
  value?: string;
  onChange?: (html: string) => void;
  placeholder?: string;
  /** Min height of the editor area in pixels. Default 160. */
  minHeight?: number;
  readOnly?: boolean;
}

/** Toolbar tuned for transactional messages — no headings, no media. */
const TOOLBAR = [
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  ["clean"],
];

const QUILL_MODULES = { toolbar: TOOLBAR };
const QUILL_FORMATS = [
  "bold", "italic", "underline", "strike",
  "list", "bullet", "link",
];

/**
 * Thin wrapper around react-quill-new used for ticket message bodies.
 *
 * Wrapped in a div with a fixed min-height so the editor doesn't collapse
 * to one line when empty and so its toolbar sits flush above the content.
 */
export const RichTextEditor = ({
  value,
  onChange,
  placeholder,
  minHeight = 160,
  readOnly,
}: RichTextEditorProps) => {
  return (
    <div
      style={{ minHeight: minHeight + 42 /* toolbar */ }}
      className="cyb-rich-editor"
    >
      <ReactQuill
        theme="snow"
        value={value ?? ""}
        onChange={(html) => onChange?.(html)}
        placeholder={placeholder}
        readOnly={readOnly}
        modules={QUILL_MODULES}
        formats={QUILL_FORMATS}
        style={{ minHeight }}
      />
      <style>{`
        .cyb-rich-editor .ql-container {
          min-height: ${minHeight}px;
          font-size: 14px;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        .cyb-rich-editor .ql-toolbar {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        .cyb-rich-editor .ql-editor {
          min-height: ${minHeight}px;
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
